import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CAMPAIGN } from "@/constants/testIds";
import { Plus, ArrowUpRight } from "lucide-react";

const statusBadge = {
  draft:    "bg-gray-100 text-gray-600",
  active:   "bg-emerald-50 text-emerald-700",
  paused:   "bg-amber-50 text-amber-700",
  archived: "bg-gray-100 text-gray-500",
};

export default function Campaigns() {
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/campaigns").then((r) => setItems(r.data)); }, []);

  return (
    <div className="p-8 space-y-6 max-w-[1500px]">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-3xl font-display text-gray-900">Campaigns</h1>
          <p className="text-sm text-gray-500 mt-1">{items.length} campaign{items.length === 1 ? "" : "s"}</p>
        </div>
        <Link to="/campaigns/new" data-testid={CAMPAIGN.createBtn}
          className="btn-brand inline-flex items-center gap-2 px-4 py-2 text-sm">
          <Plus className="h-4 w-4" /> New campaign
        </Link>
      </div>

      {items.length === 0 && (
        <div className="bg-white border border-dashed border-gray-300 rounded-xl p-12 text-center">
          <p className="text-sm text-gray-500">No campaigns yet — create one to start building variations.</p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((c, idx) => (
          <Link key={c.id} to={`/campaigns/${c.id}`}
            data-testid={CAMPAIGN.card(c.id)}
            className="bg-white border border-gray-200 rounded-xl p-5 hover:shadow-md hover:border-gray-300 transition-all group fade-up"
            style={{ animationDelay: `${idx * 30}ms` }}>
            <div className="flex items-start justify-between">
              <span className="inline-block w-3 h-3 rounded-sm" style={{ background: c.brand_color || "#ee9037" }} />
              <ArrowUpRight className="h-4 w-4 text-gray-300 group-hover:text-brand transition-colors" />
            </div>
            <div className="mt-4 flex items-center gap-2">
              <span className="text-[10px] font-medium uppercase tracking-wider text-gray-500">{c.objective}</span>
              <span className={`text-[10px] font-medium uppercase tracking-wider px-1.5 py-0.5 rounded ${statusBadge[c.status] || "bg-gray-100 text-gray-600"}`}>
                {c.status}
              </span>
            </div>
            <h3 className="font-display text-xl text-gray-900 mt-1.5">{c.name}</h3>
            <p className="text-sm text-gray-500 mt-2 line-clamp-2 min-h-[2.5em]">{c.description || "—"}</p>
            <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between text-xs">
              <span className="text-gray-500">{c.variation_count || 0} variations</span>
              <span className="text-brand font-medium">{c.render_count || 0} renders</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
